import { createFeatureSelector, createSelector } from '@ngrx/store';
import { _STATE_ADVICE_FEATURE_KEY, State } from './advice.reducer';

export const getStateAdviceState = createFeatureSelector<State>(
	_STATE_ADVICE_FEATURE_KEY,
);

export const getStateAdviceCategories = createSelector(
	getStateAdviceState,
	(state: State) => state.categories,
);

export const getStateAdviceAllArticles = createSelector(
	getStateAdviceState,
	(state: State) => state.articles,
);

export const getStateAdviceFeatured = createSelector(
	getStateAdviceState,
	(state: State) => state.featured,
);

export const getStateAdviceSingleArticle = createSelector(
	getStateAdviceState,
	(state: State) => state.singleArticle,
);

export const getStateAdviceSearch = createSelector(
	getStateAdviceState,
	(state: State) => state.search,
);

export const getStateAdviceSearchTerm = createSelector(
	getStateAdviceState,
	(state: State) => state.searchTerm,
);

export const getStateAdvicePage = createSelector(
	getStateAdviceState,
	(state: State) => state.page,
);

export const getStateAdviceOffset = createSelector(
	getStateAdviceState,
	(state: State) => state.offset,
);
